import React from "react";

const GlobalLocation = () => {
    return (
        <div className="w-full text-gray-800">

            {/* HERO */}
            <section className="bg-[#f4efe9] py-20 px-6">
                <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">
                    <div>
                        <h1 className="text-4xl md:text-5xl font-bold leading-tight">
                            What it means to be <br />
                            <span className="text-orange-500">TechSPR</span>
                        </h1>
                        <p className="mt-6 text-gray-600 max-w-xl">
                            We’re a trusted digital engineering and enterprise modernization
                            partner. We help our clients anticipate what’s next and deliver
                            meaningful change at speed.
                        </p>
                        <div className="mt-8 flex gap-4">
                            <button className="bg-orange-500 text-white px-6 py-3 rounded">
                                Learn More
                            </button>
                            <button className="border px-6 py-3 rounded">
                                Contact Us
                            </button>
                        </div>
                    </div>
                    <img
                        src="/images/company/globle/hero.jpg"
                        alt="TechSPR team"
                        className="rounded-lg"
                    />
                </div>
            </section>

            {/* AWARDS */}
            <section className="bg-blue-950 text-white py-16 px-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-8">
                        Awards and Recognition
                    </h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            {
                                img: "/images/award-1.jpg",
                                title: "TechSPR recognized as a leader",
                                desc: "Recognized for excellence in digital engineering and cloud.",
                            },
                            {
                                img: "/images/award-2.jpg",
                                title: "Top Innovator in AI Solutions",
                                desc: "Awarded for breakthrough innovation in artificial intelligence.",
                            },
                            {
                                img: "/images/award-3.jpg",
                                title: "Best Digital Transformation Partner",
                                desc: "Honored for delivering impactful enterprise transformation.",
                            },
                        ].map((item, i) => (
                            <div key={i} className="bg-white text-black p-6 rounded">
                                {/* Same layout — only dynamic content */}
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="mb-4 rounded"
                                />

                                <h4 className="font-semibold mb-2">{item.title}</h4>

                                <p className="text-sm text-gray-600">{item.desc}</p>

                                <button className="text-orange-500 mt-4 text-sm">
                                    Read more →
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* INDUSTRY EXPERTISE */}
            {/* <section className="py-20 px-6 bg-white">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-10">
                        Industry Expertise and Solutions
                    </h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                        {[
                            "Banking",
                            "Healthcare",
                            "Life Sciences",
                            "Insurance",
                            "Hi-Tech",
                            "Industrial",
                            "Telecom",
                            "ISVs",
                        ].map((item) => (
                            <div
                                key={item}
                                className="border rounded p-6 text-center font-medium"
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* SERVICES */}
            {/* <section className="bg-gray-50 py-20 px-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-10">Services Lines</h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                        {[
                            "Digital Strategy",
                            "Cloud & Infrastructure",
                            "Data & AI",
                            "Enterprise Platforms",
                            "Product Engineering",
                            "CX Transformation",
                            "Automation",
                            "Security",
                        ].map((service) => (
                            <div
                                key={service}
                                className="bg-white p-6 rounded shadow text-center"
                            >
                                <div className="w-12 h-12 bg-orange-100 rounded-full mx-auto mb-4" />
                                <p className="font-medium">{service}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* 30 YEAR JOURNEY */}
            {/* <section className="bg-[#2f2a3a] text-white py-20 px-6">
                <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-3xl font-semibold mb-4">
                            TechSPR 30-Year Journey
                        </h2>
                        <p className="text-gray-300">
                            From a startup to a global digital engineering leader — our journey
                            reflects resilience, innovation, and trust.
                        </p>
                    </div>
                    <img
                        src="/images/road.jpg"
                        alt="Journey"
                        className="rounded-lg"
                    />
                </div>
            </section> */}

            {/* LEADERSHIP */}
            {/* <section className="py-20 px-6 bg-white">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-10">
                        TechSPR Leadership
                    </h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div key={i} className="text-center">
                                <div className="w-32 h-32 mx-auto rounded-full bg-gray-200 mb-4" />
                                <h4 className="font-semibold">Leader Name</h4>
                                <p className="text-sm text-gray-600">Designation</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* VALUES */}
            <section className="bg-gray-900 text-white py-20 px-6">
                <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-6">
                    {[
                        "Ingenious",
                        "TechSPR",
                        "Confident",
                    ].map((value) => (
                        <div
                            key={value}
                            className="h-64 bg-gray-800 flex items-end p-6 text-xl font-semibold"
                        >
                            {value}
                        </div>
                    ))}
                </div>
            </section>

            {/* WORLDWIDE LOCATIONS */}
            <section className="py-20 px-6 bg-white">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-10">
                        Worldwide Locations
                    </h2>

                    <div className="grid md:grid-cols-4 gap-8 text-sm">
                        {[
                            "United States",
                            "Canada",
                            "Mexico",
                            "Brazil",
                            "UK",
                            "Germany",
                            "Netherlands",
                            "Poland",
                            "India",
                            "Sri Lanka",
                            "Singapore",
                            "Australia",
                        ].map((country) => (
                            <div key={country}>
                                <h4 className="font-semibold mb-2">{country}</h4>
                                <p className="text-gray-600">
                                    Multiple delivery and innovation centers
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* JOIN TEAM */}
            <section className="bg-[#f4efe9] py-16 px-6 text-center">
                <h2 className="text-3xl font-semibold mb-6">
                    Join the TechSPR team
                </h2>
                <button className="bg-orange-500 text-white px-8 py-3 rounded">
                    Explore Careers
                </button>
            </section>

            {/* CONTACT */}
            {/* <section className="bg-white py-20 px-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-10">Contact us</h2>
                    <form className="grid md:grid-cols-3 gap-6">
                        <input className="border p-3 rounded" placeholder="First Name" />
                        <input className="border p-3 rounded" placeholder="Last Name" />
                        <input className="border p-3 rounded" placeholder="Email" />
                        <textarea
                            className="md:col-span-3 border p-3 rounded"
                            placeholder="Message"
                            rows="4"
                        />
                        <button className="md:col-span-3 bg-orange-500 text-white py-3 rounded">
                            Submit
                        </button>
                    </form>
                </div>
            </section> */}

        </div>
    );
};

export default GlobalLocation;
